import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex flex-col">
      {/* Header */}
      <header className="max-w-7xl mx-auto px-4 sm:px-6 py-5 sm:py-6 w-full">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 group">
            <img 
              src="/logo-icon.png" 
              alt="SiteScope" 
              className="w-12 h-12 sm:w-12 sm:h-12 md:w-14 md:h-14 transition-transform group-hover:scale-105" 
            />
            <span className="text-2xl sm:text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100">
              SiteScope
            </span>
          </Link>
          
          <Link 
            to="/" 
            className="text-sm sm:text-base font-medium text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >
            ← Back to Home
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16 w-full">
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 sm:p-10 shadow-lg border border-gray-200 dark:border-gray-700">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-6">
            Refund Policy
          </h1>
          
          <div className="prose prose-blue dark:prose-invert max-w-none">
            {/* Money-Back Guarantee */}
            <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 p-6 rounded-r-lg mb-8">
              <h2 className="text-2xl font-bold text-green-900 dark:text-green-100 mt-0 mb-3">
                💯 30-Day Money Back Guarantee
              </h2>
              <p className="text-green-800 dark:text-green-200 text-lg mb-0">
                We stand behind our service. If you're not satisfied with SiteScope for any reason, 
                you can request a full refund within 30 days of your purchase.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-8 mb-4">
              How to Request a Refund
            </h2>
            <ol className="space-y-3 text-gray-700 dark:text-gray-300">
              <li>Email us at <a href="mailto:support@sitescope.work" className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300">support@sitescope.work</a> with "Refund Request" in the subject line</li>
              <li>Include your account email address and reason for refund (optional)</li>
              <li>We'll process your refund within 2-3 business days</li>
              <li>Money will be returned to your original payment method in 5-10 business days</li>
            </ol>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-8 mb-4">
              What's Covered
            </h2>
            <ul className="space-y-2 text-gray-700 dark:text-gray-300">
              <li>✅ All paid plans (Pro, Enterprise)</li>
              <li>✅ Monthly and annual subscriptions</li>
              <li>✅ Full refund within 30 days of purchase</li>
              <li>✅ No questions asked policy</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-8 mb-4">
              Not Covered
            </h2>
            <ul className="space-y-2 text-gray-700 dark:text-gray-300">
              <li>❌ Refund requests after 30 days from purchase date</li>
              <li>❌ Free plan (no payment made)</li>
              <li>❌ Partial refunds for partial months</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-8 mb-4">
              Cancellation Policy
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              You can cancel your subscription at any time from your account settings. When you cancel:
            </p>
            <ul className="space-y-2 text-gray-700 dark:text-gray-300 mt-3">
              <li>• Your subscription will remain active until the end of your current billing period</li>
              <li>• You'll continue to have access to all features until the subscription expires</li>
              <li>• No further charges will be made</li>
              <li>• You can downgrade to our Free plan to continue using basic features</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-8 mb-4">
              Processing Time
            </h2>
            <p className="text-gray-700 dark:text-gray-300">
              Once we approve your refund request:
            </p>
            <ul className="space-y-2 text-gray-700 dark:text-gray-300 mt-3">
              <li>• <strong>Credit/Debit Cards:</strong> 5-10 business days</li>
              <li>• <strong>PayMongo Wallet:</strong> 2-3 business days</li>
              <li>• Refund processing times may vary depending on your bank or payment provider</li>
            </ul>

            <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-500 p-6 rounded-r-lg mt-8">
              <h3 className="text-xl font-bold text-blue-900 dark:text-blue-100 mt-0 mb-3">
                💡 Have Questions?
              </h3>
              <p className="text-blue-800 dark:text-blue-200 mb-0">
                If you have any questions about our refund policy or need assistance with a refund, 
                please contact us at <a href="mailto:support@sitescope.work" className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 font-semibold">support@sitescope.work</a>. 
                We're here to help!
              </p>
            </div>

            <p className="text-sm text-gray-500 dark:text-gray-400 mt-8 mb-0">
              Last updated: November 7, 2025
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
